"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const js_joda_1 = require("js-joda");
exports.hki = js_joda_1.ZoneId.of('Europe/Helsinki');
exports.fiLocalDateFormat = js_joda_1.DateTimeFormatter.ofPattern('d.M.yyyy');
exports.fiDateTimeFormat = js_joda_1.DateTimeFormatter.ofPattern('d.M.yyyy H:mm');
exports.fiLocalTimeFormat = js_joda_1.DateTimeFormatter.ofPattern('H:mm');
exports.isoLocalDateFormat = js_joda_1.DateTimeFormatter.ISO_LOCAL_DATE;
exports.isoDateTimeFormat = js_joda_1.DateTimeFormatter.ISO_INSTANT;
exports.isoLocalTimeFormat = js_joda_1.DateTimeFormatter.ISO_LOCAL_TIME;
exports.startOfYearZdt = (i) => js_joda_1.LocalDate.of(js_joda_1.LocalDate.ofInstant(i, exports.hki).year(), 1, 1).atStartOfDay(exports.hki);
exports.localDateFormatterOf = (fmt) => {
    switch (fmt) {
        case 'fi': return exports.fiLocalDateFormat;
        case 'iso': return exports.isoLocalDateFormat;
        default: return fmt;
    }
};
exports.dateTimeFormatterOf = (fmt) => {
    switch (fmt) {
        case 'fi': return exports.fiDateTimeFormat;
        case 'iso': return exports.isoDateTimeFormat;
        default: return fmt;
    }
};
exports.localTimeFormatterOf = (fmt) => {
    switch (fmt) {
        case 'fi': return exports.fiLocalTimeFormat;
        case 'iso': return exports.isoLocalTimeFormat;
        default: return fmt;
    }
};
